//Edit Container for various measures
import React from 'react'
import { connect } from 'react-redux'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import Dialog from '../../common/dialog'
import MarkerDetails from '../common/marker-details'
import PhotoDetails from '../common/photo-details'
import ShapeDetails from '../common/shape-details'
import TrackDetails from '../common/track-details'
import RouteBuilder from '../tools/route-builder'
import ThreeDMarkerDetails from '../../../threedmap/add-3dmap-items/add-marker/index'
import ThreeDPhotoMarkerDetails from '../../../threedmap/add-3dmap-items/add-photo/add-photo'

class Editable extends Dialog {
  constructor(props) {
    super(props)
  }

  render() {
    if (!this.props.leftToolbarState.editable) {
      return null
    }
    const { measureType, markerType } = this.props.leftToolbarState.editable,
      shapes = ['line', 'circle', 'polygon', 'track', 'boundary']
    const { collapseLeftToolbar, mapReference } = this.props
    const onCloseButton = () => {
      collapseLeftToolbar()
    }
    return (
      <div className='left-expanded-content-container'>
        {/* Tracks and routes use their own redesigned panel/header; suppress the generic header. */}
        {this.props.is3dMapselected || measureType === 'track' || measureType === 'route' ? null :
          <div className='left-expanded-header-container'>
            <span className='left-expanded-header'>{measureType == 'marker' ? '             ' : this.props.is3dMapselected ? '' : `Edit ${measureType}`}</span>
            <div className='default-close left-dialog-close' onClick={onCloseButton}></div>
          </div>}
        {
          markerType?.usageFlag == 3 && this.props.is3dMapselected ? <ThreeDMarkerDetails type={'huntStand'} /> :
            measureType === 'marker' ? this.props.is3dMapselected ? <ThreeDMarkerDetails /> : <MarkerDetails /> :
              measureType === 'photo' ? this.props.is3dMapselected ? <ThreeDPhotoMarkerDetails /> : <PhotoDetails /> :
                measureType === 'track' ? <TrackDetails /> :
                  measureType === 'route' ? <RouteBuilder key={this.props.leftToolbarState.editable.id} route={this.props.leftToolbarState.editable} onClose={onCloseButton} /> :
                  shapes.indexOf(measureType) !== -1 ? <ShapeDetails />
                    : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  is3dMapselected: state.is3dMapselected
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Editable)
